import type { UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { globalQueryClient } from "queries/queryClient";

import { SelectOptionModel } from "@/domain/model/select";
import { QUERIES } from "@/enums/queries";

import { loadCustomerFieldsTypes } from "./services/loadCustomerFieldsTypes";

export const useLoadCustomerFieldsTypes = (
  options?: UseQueryOptions<SelectOptionModel[], Error>,
): UseQueryResult<SelectOptionModel[], Error> => {
  return useQuery({
    queryKey: [QUERIES.CUSTOMER_FIELDS.TYPES],
    queryFn: async () => await loadCustomerFieldsTypes(),
    staleTime: 60 * 1000 * 10, // 10 minutes
    ...options,
  });
};

export const invalidateLoadCustomerFieldsTypes = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.CUSTOMER_FIELDS.TYPES],
    exact: false,
  });
};
